<template>
	<el-container class="is-vertical">
		<Header ref="header" />
		<el-main class="tu-main" :style="{ minHeight: (clientHeight - 350) + 'px' }">
			<div style="margin-bottom: 20px; display: flex; justify-content: space-between;">
				<div style="font-size:14px;cursor: pointer;" @click="userType==1?dialogSwitchArea=true:''">{{$t('Current Time Zone')}}: <span>{{currentZone}}</span> <el-icon v-if="userType==1"><i class="fa fa-caret-down"></i></el-icon></div>
				<div><i class="fa fa-clock-o"></i> <span style="font-size:14px;">{{ currentTime }}</span></div>
			</div>
			<div v-if="isLogin && userType==2 && userInfo.is_pass != 1" class="tu-steps-class">
				<el-steps :active="stepActive" align-center>
					<el-step :title="$t('Create profile')" @click="goTo(1)"></el-step>
					<el-step :title="$t('Set availability')" @click="goTo(2)"></el-step>
					<el-step :title="$t('Account details')" @click="goTo(3)"></el-step>
				</el-steps>
			</div>
			<router-view />
		</el-main>
		<el-dialog
		    v-model="dialogSwitchArea"
		    :title="$t('course.timezone')"
		    width="30%">
		    <el-select v-model="timezone" size="medium" clearable filterable style="width: 100%;">
				<el-option v-for="item, i in zoneList" :label="item.name" :value="item.zone"></el-option>
			</el-select>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="dialogSwitchArea=false">{{ $t('cancel') }}</el-button>
					<el-button type="primary" @click="handleConfirm">{{ $t('OK') }}</el-button>
				</span>
			</template>
		</el-dialog>
		<Footer ref="footer" />
		<el-dialog
		    v-model="dialogVisible"
		    title=""
		    width="500px"
		    :showClose="false"
		    :close-on-click-modal="false"
		    :close-on-press-escape="false"
		    custom-class="layouts-dialog"
		  >
		    <div class="layouts-dialog-wrap">
		    	<div>Please review and confirm our new cancellation policy.</div>
		    	<div>1.	Students can cancel for free up to 24 hours before the lesson start time.</div>
				<div>2.	Cancellations within 24 hours may incur a charge, unless the system cancels the lesson due to lack of student or tutor confirmation. </div>
				<div>3.	When canceling within 24 hours on behalf of a student, tutors can choose a charge of 0%, 50%, or 100% of the lesson price. </div>
				<div>4.	You have 24 hours to decide, otherwise, a 50% charge is applied automatically. </div>
				<div>5.	Lessons cancelled after the start time or without prior notice will be charged full price.</div>
		    </div>
		    <template #footer>
		      <div class="layouts-dialog-footer">
		        <el-button type="primary" @click="dialogVisibleClose">
		          I Know
		        </el-button>
		      </div>
		    </template>
		</el-dialog>
	</el-container>
	<el-backtop />
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import { ElNotification } from 'element-plus'
import MessageApi from '@/api/message'
import { checkToken } from '@/utils'
import TimeControl from '@/utils/time-control'
import Config from '@/utils/config'
import CommonApi from '@/api/common.js'
import storage from 'store'

export default {
	name: "BasicLayout",
	components: {
		Header,
		Footer
	},
	data() {
		return {
			dialogSwitchArea: false,
			clientHeight: '',
			currentTime: '',
			currentZone: '',
			setInt: null,
			timezone: '',
			zoneList: [],
			dialogVisible: false,
			cancelKey: 'tutor-cancel-key-20240721'
		}
	},
	created () {
		this.clientHeight = document.documentElement.clientHeight;
		if(!storage.get(this.cancelKey)) {
			this.dialogVisible = true;
		}
		this.timezone = this.userInfo.timezone;
		this.onCurrentZone();
	},
	mounted() {
		// this.$store.state.timer = setInterval(this.handleNotification, 15000);
		this.handleNotification();
		this.initStoreData();
	},
	computed: {
		...mapGetters([
			'isLogin', 'userInfo', 'userType', 'isStudent', 'isTeacher'
		]),
		stepActive() {
			if(this.isTeacher && this.userInfo.is_pass != 1) {
				if(this.userInfo.isPass == 0) {
					return 3;
				}
				return this.userInfo.isPass - 1;
			}
			return 3;
		}
	},
	methods: {
		onCurrentZone() {
			this.zoneList = Config.timeZoneList();
			this.zoneList.forEach(item => {
				item.name = item.name + ", " + item.desc;
			})
			this.currentTime = TimeControl.getCurrentTime(this.timezone);
			if(!!this.setInt) {
				clearInterval(this.setInt);
			}
			this.setInt = setInterval(() => {
				this.currentTime = TimeControl.getCurrentTime(this.timezone);
			}, 30000);

			let currentZone = Config.timeZoneList(this.timezone);
			let name = currentZone.name ? (currentZone.name + ", " + currentZone.desc) : '';
			this.currentZone = name || this.timezone;
		},
		handleNotification() {
			return ;//先关闭吧！
			if(checkToken() === false) {
				return ;
			}
			if(this.$store.state.timer) {
				clearTimeout(this.$store.state.timer);
			}
			let that = this;
			MessageApi.notification().then(res => {
				if(!!res.data && !!res.data.title) {
					let desc = `<span>${res.data.desc}</span> <a href="javascript:;">${this.$t('Click to view')}</a>`;
					ElNotification({
						title: res.data.title,
						dangerouslyUseHTMLString: true,
						message: desc,
						type: 'info',
						duration: 5500,
						onClick: function() {
							if(!!res.data.uri) {
								let params = [res.data.message_id];
								MessageApi.readed(params).then(res => {});
								that.$router.push(res.data.uri);
							}
						}
					})
				}
				this.$store.state.timer = setTimeout(this.handleNotification, 15000);
			})
		},
		initStoreData() {
			if(this.isLogin) {
				if(this.isTeacher) {
					this.$store.dispatch('GetMyStudentList')
				} else {
					this.$store.dispatch('GetMyTeacherList')
				}
				this.$store.dispatch('GetSubjectData')

				checkToken();
			}
		},
		goTo(value) {
			value = value - 1;
			if(this.stepActive >= value) {
				if(value == '0') {
					this.$router.push({ path: "/tu/information" });
				} else if(value == '1') {
					this.$router.push({ path: "/tu/availability" });
				} else {
					this.$router.push({ path: "/tu/account" });
				}
			}
		},
		dialogVisibleClose() {
			this.dialogVisible = false;
			storage.set(this.cancelKey, (new Date));
		},
		handleConfirm() {
			CommonApi.settimezone({zone: this.timezone}).then(res => {
				this.$store.dispatch('GetUserInfo').then(res => {
					this.onCurrentZone();
					location.reload(true);
				});
				this.dialogSwitchArea = false;
			})
		}
	},
	beforeUnmount() {
		if(!!this.$store.state.timer) {
			clearInterval(this.$store.state.timer);
			this.$store.state.timer = null;
		}
	}
}
</script>
<style lang="less">
.el-main.tu-main {
	margin: 0 auto;
	margin-top: 61px;
	width: var(--tu-main-width);
}
.tu-main {
	.tu-steps-class {
		padding: 22px 0;

		.el-step {
			.el-step__title {
				cursor: pointer;
			}
		}
	}
}

.layouts-dialog .el-dialog__header {
	display: none;
}

.layouts-dialog-wrap {
	font-size: 14px;
	line-height: 22px;
	div:first-child {
		font-weight: bold;
		font-size: 16px;
		margin-bottom: 10px;
	}
}

.layouts-dialog-footer {
	display: flex;
	align-items: center;
	justify-content: center;
}
</style>